module.exports = __webpack_public_path__ + "static/media/4B.2ce00372.jpg";